import React from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FlightIcon from '@mui/icons-material/Flight';
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../../notification';
import { useMediaQuery } from '@mui/material';

export const NAVBAR_HEIGHT = '64px';

const StyledAppBar = styled(AppBar)({
  zIndex: 1300,
  boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1)',
  background: '#1976d2',
});

const MenuButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
}));

const LogoutButton = styled(Button)(({ theme }) => ({
  marginLeft: 'auto',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
}));

const Navbar = ({ handleMenuClick }) => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user')) || {};
  const username = userData.first_name || userData.username || '';
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const handleLogoutClick = async () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <StyledAppBar position="fixed">
      <Toolbar sx={{ background:'#000057'}}>
      {isMobile && (
        <MenuButton color="inherit" aria-label="menu" onClick={handleMenuClick}>
          <MenuIcon />
        </MenuButton>
      )}

        <FlightIcon style={{ marginRight: 8 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontFamily: "'Roboto Slab', serif" }}>
          Pegasus
        </Typography>
        
        
        <Typography variant="subtitle1" style={{ marginRight: 16 }}>
          Bienvenido, {username}
        </Typography>
        <LogoutButton 
          color="inherit" 
          startIcon={<ExitToAppIcon />} 
          onClick={handleLogoutClick}
        >
          Cerrar Sesión
        </LogoutButton>
      </Toolbar>
    </StyledAppBar>
  );
};

export default Navbar;
